import React, { useEffect, useState } from 'react';
import { Row, Form, Input, Col, Select } from 'antd';
import {
  SubmitButton,
  SubmitButtonCol,
  PhoneNumberCol
} from '../styledComponents.js';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { NAME_REGEX_CHECK } from '../../../Constants/StringConstants.js';
import { fetchUnassignedAuthors } from '../../../Apis/Scribe.js';

const { Option } = Select;

const AddScribesForm = ({ selectedItem, submitHandler, submitLoading }) => {
  const [form] = Form.useForm();
  const [Updated, setUpdated] = useState({ phone: false, other: false });
  const [changedValues, setchangedValues] = useState();
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    fetchUnassignedAuthors()
      .then(response => {
        const list = response.data?.result || [];
        if (selectedItem?.assignedDoctor) {
          const { doctorId, doctorName, email } = selectedItem.assignedDoctor;
          const alreadyInList = list.some(d => d.doctorId === doctorId);
          if (!alreadyInList) {
            setDoctors([{ doctorId, doctorName, email }, ...list]);
          } else {
            setDoctors(list);
          }
        } else {
          setDoctors(list);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem) {
      const nameParts = (selectedItem.fullName || '').trim().split(/\s+/);
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || '';

      const phoneNumber =
        selectedItem.phoneNumber?.number
          ? {
              countryCode: selectedItem.phoneNumber.countryCode,
              number: selectedItem.phoneNumber.countryCode.concat(
                selectedItem.phoneNumber.number
              )
            }
          : '';

      const formData = {
        firstName,
        lastName,
        email: selectedItem.email || '',
        assignedDoctorId: selectedItem.assignedDoctor?.doctorId,
        phoneNumber
      };

      form.setFieldsValue(formData);
      setchangedValues(formData);
    }
    // eslint-disable-next-line
  }, [selectedItem]);

  const phoneNumberChanged = (value, country) => {
    let countryCode = country.dialCode;
    form.setFieldsValue({
      phoneNumber: {
        countryCode: countryCode
      }
    });
    let changedPHCode =
      String(selectedItem?.phoneNumber?.countryCode) !==
      String(country.dialCode);
    let changedPH =
      String(selectedItem?.phoneNumber?.number).slice(0, 11) !== String(value);

    setUpdated({ ...Updated, phone: changedPHCode || changedPH });
  };

  const onvalueUpdate = values => {
    if (!Boolean(values?.phoneNumber)) {
      setchangedValues({ ...changedValues, ...values });
      setUpdated({
        ...Updated,
        other:
          JSON.stringify({ ...changedValues, ...values }) !==
          JSON.stringify(selectedItem)
      });
    }
  };

  return (
    <Form
      form={form}
      layout='vertical'
      onFinish={values => submitHandler(values)}
      onValuesChange={values => onvalueUpdate(values)}
    >
      <Row justify='center'>
        <Col span={24}>
          <Form.Item
            label='First Name'
            name='firstName'
            rules={[
              { required: true, message: 'First Name is required' },
              {
                pattern: new RegExp(NAME_REGEX_CHECK),
                message: 'Please enter only alphabets'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Last Name'
            name='lastName'
            rules={[
              { required: true, message: 'Last Name is required' },
              {
                pattern: new RegExp(NAME_REGEX_CHECK),
                message: 'Please enter only alphabets'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Email'
            name='email'
            rules={[
              { required: true, message: 'Email is required' },
              {
                type: 'email',
                message: 'Please enter valid email'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Assigned Provider'
            name='assignedDoctorId'
          >
            <Select
              size='large'
              showSearch
              optionFilterProp='children'
              placeholder='Select a doctor'
              getPopupContainer={trigger => trigger.parentNode}
            >
              <Option key='none' value=''>
                None
              </Option>
              {doctors.map(doctor => (
                <Option key={doctor.doctorId} value={doctor.doctorId}>
                  {doctor.doctorName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <PhoneNumberCol span={24}>
          <Form.Item noStyle>
            <Form.Item
              name={['phoneNumber', 'countryCode']}
              noStyle
            ></Form.Item>
            <Form.Item
              label='Phone Number'
              name={['phoneNumber', 'number']}
              rules={[{ required: true, message: 'Phone Number is required' }]}
            >
              <PhoneInput country={'us'} onChange={phoneNumberChanged} />
            </Form.Item>
          </Form.Item>
        </PhoneNumberCol>
        <SubmitButtonCol span={24}>
          <SubmitButton
            htmlType='submit'
            type='primary'
            size='large'
            shape='round'
            disabled={
              !(Updated.phone || Updated.other) && Boolean(selectedItem)
            }
            loading={submitLoading}
          >
            Submit
          </SubmitButton>
        </SubmitButtonCol>
      </Row>
    </Form>
  );
};

export default AddScribesForm;
